export const isNullableBoolean = (value: unknown): value is boolean | null =>
  typeof value === 'boolean' || value === null

export const isOptionalIsoDateString = (value: unknown): value is string | undefined =>
  value === undefined || (typeof value === 'string' && !isNaN(new Date(value).getTime()))

/**
 * Validates a plain object against a map of per-key guards. Every key in `guards` must exist in `value`
 * (even if its guard accepts `undefined`) and pass its guard; extra keys on `value` are ignored.
 */
export function matchesShape<T extends Record<string, unknown>>(
  value: unknown,
  guards: { [K in keyof T]: (v: unknown) => v is T[K] },
): value is T {
  if (typeof value !== 'object' || value === null) return false
  const v = value as Record<string, unknown>
  return (Object.keys(guards) as (keyof T)[]).every((key) => guards[key](v[key as string]))
}
